import { gql } from "./api";

export const getAcademyModule = async ({uuid, token, chapter, module, sub, user_uuid}: {
    uuid: string;
    token: string;
    chapter: number | undefined;
    module: number | undefined;
    sub: number | undefined;
    user_uuid: string | undefined;
  }) => {
    const response = await gql({
        query: `
            mutation GetAcademyModule {
                getAcademyModule(
                    academyModuleInput: {
                        chapter: ${chapter}
                        module: ${module}
                        sub: ${sub}
                        token: "${token}"
                        uuid: "${uuid}"
                        user_uuid: "${user_uuid}"
                    }
                ) {
                    id
                    title {
                        EN
                        NL
                    }
                    intro {
                        EN
                        NL
                    }
                    video {
                        file
                        types
                    }
                    next
                    quizzes {
                        answer
                        question {
                            EN
                            NL
                        }
                        choices {
                            EN {
                                answer
                                context
                            }
                            NL {
                                answer
                                context
                            }
                        }
                        user_answer
                        correct
                    }
                }
            }
        `,
        returnFunc: 'getAcademyModule'
    });

    return response;
};


export const updateAcademyProgress = async ({
  uuid,
  token,
  user_uuid,
  academy_id,
}: {
  uuid: string;
  token: string;
  user_uuid: string;
  academy_id: number;
}) => {
  const response = await gql({
    query: `
      mutation CreateActivity {
        createProgress(
          createProgressInput: {
            uuid: "${uuid}"
            token: "${token}"
            user_uuid: "${user_uuid}"
            academy_id: ${academy_id}
          }
        ) {
          progress {
            chapter
            label
            available
            status
            description {
              EN
              NL
            }
            modules {
              id
              title
              status
              available
              link
              next
              label {
                EN
                NL
              }
            }
          }
        }
      }
    `,
    returnFunc: 'createProgress',
  });

  return response;
};


export const setUserQuizAnswer = async ({
  uuid,
  token,
  user_uuid,
  chapter,
  module,
  sub,
  question,
  answer,
  correct
}: {
  uuid: string;
  token: string;
  user_uuid: string;
  chapter: string;
  module: string;
  sub: string;
  question: number;
  answer: number;
  correct: boolean;
}) => {

  const response = await gql({
    query: `mutation CreateActivity {
              createUserQa(
                  createUserQaInput: {
                      uuid: "${uuid}"
                      token: "${token}"
                      user_uuid: "${user_uuid}"
                      chapter: "${chapter}"
                      module: "${module}"
                      sub: "${sub}"
                      question: ${question}
                      answer: ${answer}
                      correct: ${correct}
                  }
              ) {
                  uuid
              }
      }`,
    returnFunc: 'createUserQa',
  });

  return response;
};

